<script setup lang="ts">
import { Light } from '@enums/light';
import CheckableTagGroup from '@pages/search/components/filters/CheckableTagGroup.vue';

interface LightProps {
  selected?: string[];
}

const { selected = [] } = defineProps<LightProps>();

const emit = defineEmits<{(e: 'update:selected', value: string[]): void}>();

const lightOptions = [
  Light.NATURAL,
  Light.MIXED,
  Light.ARTIFICIAL,
];
</script>

<template>
  <CheckableTagGroup
    :options="lightOptions"
    :selected="selected"
    translation-prefix="search.filters.other_filters.light"
    @update:selected="emit('update:selected', $event)"
  />
</template>
